module.exports = __webpack_public_path__ + "img/sound.a7c5ba59.png";